"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../../core/conversions/DataObjectConverter");
/**
 * Serialization/deserialization of {@link SelloutImpactReportFilterDTO}.
 *
 * @author Jan Prokop
 */


var SelloutImpactReportFilterDTOConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(SelloutImpactReportFilterDTOConverter, _DataObjectConverter_);

  function SelloutImpactReportFilterDTOConverter() {
    _classCallCheck(this, SelloutImpactReportFilterDTOConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(SelloutImpactReportFilterDTOConverter).apply(this, arguments));
  }

  return SelloutImpactReportFilterDTOConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.SelloutImpactReportFilterDTOConverter = SelloutImpactReportFilterDTOConverter;